/**
 * Constants for the view URLs.
 * @type {{[string]: string}}
 */
export const endpointUrl = {
    PLAYGROUND: 'graphql/playground',
    CREATE_ENDPOINT: 'graphql/endpoint/create',
    ENDPOINT_MANAGEMENT: 'graphql/endpoints'
};
